import {
  type AcquisitionSettingsUpdate,
  acquisitionSettingsSchema,
} from "@backchannel/tax-contracts";
import {
  type ArgonSyntheticAdmission,
  argonSyntheticAcceptanceSchema,
  argonSyntheticAdmissionSchema,
  argonSyntheticEligibilitySchema,
} from "@backchannel/tax-contracts";
import {
  type CalculationRulesetOptionsQuery,
  calculationMemorySchema,
  calculationRulesetOptionsPageSchema,
} from "@backchannel/tax-contracts";
import {
  type CommercialFiscalExtractRequest,
  type WorkbookRowDraftEvidenceLinkRequest,
  type WorkbookRowDraftRequest,
  commercialFiscalExtractResultSchema,
  workbookRowDraftBatchResultSchema,
  workbookRowDraftDetailSchema,
  workbookRowDraftEvidenceLinkResultSchema,
  workbookRowDraftListSchema,
} from "@backchannel/tax-contracts";
import {
  type CalculationCoverageRequest,
  type LotMapping,
  type LotRepair,
  type LotRepairSuggestionRequest,
  type LotRoute,
  type ResearchMissing,
  calculationCoverageReportSchema,
  lotInspectionSchema,
  lotRepairSuggestionsSchema,
  lotUploadSessionSchema,
} from "@backchannel/tax-contracts";
import {
  calculationJobSummarySchema,
  lotAnalysisSchema,
  lotUploadSchema,
} from "@backchannel/tax-contracts";
import {
  type LotInputCorrectionRequest,
  type LotSimulationRequest,
  type UploadedLotTaskRequest,
  lotInputCorrectionListSchema,
  lotInputCorrectionSchema,
  lotSimulationResponseSchema,
} from "@backchannel/tax-contracts";
import type { NcmSearchLanguage, Session } from "@backchannel/tax-contracts";
import {
  type AutoApprovalSettingsUpdate,
  type AutonomousResearchScopeQuery,
  autoApprovalPackageStatusSchema,
  autoApprovalPreviewSchema,
  autoApprovalReportSchema,
  autoApprovalRunSchema,
  autoApprovalSettingsSchema,
  autonomousResearchOverviewSchema,
  autonomousResearchScopeSchema,
  commercialDriveWatchFilesSchema,
  commercialDriveWatchOverviewSchema,
  infraCostEstimateSchema,
} from "@backchannel/tax-contracts";
import {
  type SessionReplayChunkRequest,
  sessionReplayChunkResponseSchema,
  sessionReplayConfigSchema,
} from "@backchannel/tax-contracts";
import {
  type UploadFailureQuery,
  type UploadFailureReviewRequest,
  uploadFailureDetailSchema,
  uploadFailurePageSchema,
} from "@backchannel/tax-contracts";
import {
  type SessionActivityQuery,
  type SessionReplayLookupQuery,
  type SessionReplayQuery,
  type SessionReplaySettingsUpdate,
  sessionActivityPageSchema,
  sessionReplayDetailSchema,
  sessionReplayEventsPageSchema,
  sessionReplayLookupSchema,
  sessionReplayPageSchema,
  sessionReplaySettingsSchema,
} from "@backchannel/tax-contracts";
import {
  type CalculationRecalculate,
  type CalculatorResearchBatchCreate,
  type CalculatorResearchCreate,
  type CalculatorResearchEstimateRequest,
  type CalculatorResearchMode,
  type CalculatorResearchOriginKind,
  type CalculatorResearchSettingsUpdate,
  type CalculatorResearchStatus,
  calculationRevisionListSchema,
  calculationRevisionSchema,
  calculatorResearchCreateResultSchema,
  calculatorResearchEstimateResultSchema,
  calculatorResearchOriginStateSchema,
  calculatorResearchPageSchema,
  calculatorResearchRequestSchema,
  calculatorResearchSettingsSchema,
} from "@backchannel/tax-contracts";
import {
  type FactProposalRequest,
  type IpiRestatementRequest,
  type ProposalPlan,
  type ProposalPlanImportMode,
  type RuleProposalDraftOrigin,
  type RuleProposalDraftStatus,
  type RuleProposalDraftSubmit,
  type TaxPolicyVersionId,
  activeRulesetExportSchema,
  factProposalResultSchema,
  ipiRestatementResultSchema,
  policyReadinessSchema,
  proposalPlanImportResultSchema,
  ruleProposalDraftPageSchema,
  ruleProposalDraftSchema,
} from "@backchannel/tax-contracts";
import {
  type FiscalFactGroupConfirm,
  type FiscalFactKind,
  type FiscalFactQueueTab,
  type FiscalFactReviewGroupQuery,
  type FiscalFactReviewSessionAction,
  type FiscalFactReviewSessionStart,
  type FiscalFactScopeRestriction,
  type FiscalFactSource,
  type FiscalFactStatus,
  type FiscalFactVerification,
  type FiscalFactsSettingsUpdate,
  type StAgreement,
  type StAgreementRetireMisidentified,
  type StAgreementVerification,
  factsShadowSummarySchema,
  fiscalFactConfirmedReviewPageSchema,
  fiscalFactDetailSchema,
  fiscalFactGroupConfirmResultSchema,
  fiscalFactPageSchema,
  fiscalFactQueuePageSchema,
  fiscalFactReviewGroupDetailSchema,
  fiscalFactReviewGroupPageSchema,
  fiscalFactReviewSessionSchema,
  fiscalFactSchema,
  fiscalFactScopeCorrectionResultSchema,
  fiscalFactsSettingsSchema,
  stAgreementDetailSchema,
  stAgreementPageSchema,
  stAgreementRetireMisidentifiedResultSchema,
  stAgreementSchema,
} from "@backchannel/tax-contracts";
import {
  type BrowserAgentCredentialsUpdate,
  type BrowserAgentDemoCreate,
  type BrowserAgentSettingsUpdate,
  type BrowserAgentTaskAction,
  type BrowserAgentTaskCreate,
  type CoverageGapFindingRequest,
  type OperationSimulationRequest,
  type ResearchSweepAction,
  type ResearchSweepCreate,
  type ResearchSweepPreviewRequest,
  type ResearchSweepStatus,
  type ResearchUnitKind,
  type ResearchUnitStatus,
  type WebResearchSettingsUpdate,
  browserAgentCredentialsStatusSchema,
  browserAgentDemoDetailSchema,
  browserAgentDemoPageSchema,
  browserAgentDemoSchema,
  browserAgentFindingDailySchema,
  browserAgentFindingPageSchema,
  browserAgentPresenceSchema,
  browserAgentRecordingUrlSchema,
  browserAgentRunPageSchema,
  browserAgentRunRecordingsSchema,
  browserAgentRunSchema,
  browserAgentSettingsSchema,
  browserAgentStepListSchema,
  browserAgentTaskItemPageSchema,
  browserAgentTaskPageSchema,
  browserAgentTaskSchema,
  calculationJobPageSchema,
  coverageGapBatchResearchResponseSchema,
  coverageGapPageSchema,
  coverageGapSchema,
  evidenceTaskAssigneePageSchema,
  evidenceTaskPageSchema,
  evidenceTaskSchema,
  fiscalResearchTaskPageSchema,
  fiscalResearchTaskSchema,
  fiscalTaskPageSchema,
  fiscalTaskResultPageSchema,
  fiscalTaskSchema,
  integrationCestCatalogPageSchema,
  integrationNcmCatalogPageSchema,
  integrationRequestAttemptPageSchema,
  ncmChapterIllustrationSchema,
  ncmDescriptionsResponseSchema,
  ncmDetailResponseSchema,
  ncmSearchResponseSchema,
  operationResearchStateSchema,
  operationSimulationResponseSchema,
  passkeyCredentialListSchema,
  passkeyCredentialSchema,
  publishedRuleMatchingSchema,
  researchSweepPageSchema,
  researchSweepPreviewSchema,
  researchSweepSchema,
  researchUnitPageSchema,
  sourceRunEvidencePageSchema,
  sourceRunSchema,
  spRouteCoverageSchema,
  taxLookupJobPageSchema,
  taxLookupJobSchema,
  taxMcpCatalogSchema,
  webResearchSettingsSchema,
} from "@backchannel/tax-contracts";
import {
  type NfeAcknowledgementRequest,
  type NfeAnalysisRequest,
  type NfeDirection,
  type NfeFindingQuery,
  type NfeImportRequest,
  type NfeMonthPathQuery,
  type NfeObservedPathQuery,
  type NfePathDraftRequest,
  type NfeValidationRequest,
  type NfeWorkspaceSettingsUpdate,
  nfeAcknowledgementResultSchema,
  nfeAnalysisResultSchema,
  nfeAnalysisRunPageSchema,
  nfeFindingPageSchema,
  nfeImportBatchDetailSchema,
  nfeImportBatchPageSchema,
  nfeMonthPathDetailSchema,
  nfeMonthPathPageSchema,
  nfeObservedPathDetailSchema,
  nfeObservedPathPageSchema,
  nfePathDraftResultSchema,
  nfePeriodDetailSchema,
  nfePeriodEventPageSchema,
  nfePeriodTreeSchema,
  nfeValidationResultSchema,
  nfeWorkspaceSettingsSchema,
} from "@backchannel/tax-contracts";
import { z } from "zod";
import { productCatalogMethods } from "./client.product-catalog";
import { productImageMethods } from "./client.product-images";
import { withCommitVerification } from "./commit-verification";
import { TaxApiError, unexpectedResponseError } from "./errors";
import { insightFeedSchema } from "./insights";
import { isIdempotentReplayAllowed } from "./replay-safety";
import { type ApiRequest, type Transport, newCorrelationId } from "./transport";
import type {
  AuditEntry,
  AuditQuery,
  BrowserAgentFindingQuery,
  BrowserAgentRunQuery,
  BrowserAgentTaskItemQuery,
  BrowserAgentTaskQuery,
  BrowserAgentViewerTicket,
  CalculationDetail,
  CalculationExplain,
  CalculationJobQuery,
  CalculationListItem,
  CalculationQuery,
  CoverageGapQuery,
  CreateRuleProposalRequest,
  CursorPageResult,
  DlqReplayQueued,
  DlqReplayRequest,
  EvidenceArtifactPage,
  EvidenceBulkRequest,
  EvidenceBulkResult,
  EvidenceDecision,
  EvidenceDetail,
  EvidenceListItem,
  EvidenceQuery,
  EvidenceTask,
  EvidenceTaskCreate,
  EvidenceTaskPatch,
  EvidenceTaskQuery,
  FiscalResearchTaskCreate,
  FiscalResearchTaskQuery,
  FiscalTaskCreate,
  FiscalTaskQuery,
  FiscalTaskResultQuery,
  IntegrationKeyMetadata,
  IntegrationKeyRevoke,
  IntegrationKeyRotate,
  IntegrationKeySecretResponse,
  IntegrationKeyWrite,
  IntegrationRequestQuery,
  LinkRunRequest,
  NcmCatalogQuery,
  OverviewSummary,
  PrincipalAccessRecord,
  PrincipalAccessWrite,
  ProposalQuery,
  PublishRulesetRequest,
  PublishedRuleMatching,
  RollbackRulesetRequest,
  RuleListItem,
  RuleProposalDetail,
  RuleProposalListItem,
  RuleQuery,
  RulesetDetail,
  RulesetDiff,
  RulesetListItem,
  RulesetQuery,
  SourceDetail,
  SourceListItem,
  SourceRunEvidenceQuery,
  SourceRunQueued,
  TaxPolicyVersion,
} from "./types";

/**
 * Bulk triage is capped in three places on purpose: here, in the selection
 * state, and in the API (`BATCH_TOO_LARGE`). The UI cap exists so an operator
 * is told before they act, not after.
 */
export const BULK_TRIAGE_MAX = 100;

export const DEFAULT_PAGE_SIZE = 50;

const browserAgentViewerTicketSchema: z.ZodType<BrowserAgentViewerTicket> = z.object({
  ticket: z.string().min(1),
  url: z.string().regex(/^wss?:\/\//),
  expiresAt: z.string().datetime(),
});
export const PAGE_SIZE_OPTIONS = [25, 50, 100, 200] as const;

/**
 * Session is the gate for every protected route. Fail it before the generic
 * API budget so a cold/unreachable gateway reaches the in-app recovery state
 * promptly instead of leaving an authenticated-looking shell on screen.
 */
export const SESSION_REQUEST_TIMEOUT_MS = 12_000;

/** NF-e uploads carry up to 8 MiB decoded; give them more than a read's timeout. */
export const NFE_IMPORT_TIMEOUT_MS = 180_000;

/**
 * Creating research requests answers in a second or two, but the gateway allows
 * 60 s: the client must not give up (and show "may have completed") before the
 * gateway would, as it did at the generic 30 s.
 */
export const CALCULATOR_RESEARCH_CREATE_TIMEOUT_MS = 60_000;

/**
 * Import, coverage and task create of a sheet: the gateway allows them 60 s (Cloud Run's request
 * timeout). "Calcular todas" sends several at once, so the client waits as long as the gateway
 * would instead of giving up at the generic 30 s and calling a finished write "may have completed".
 */
export const CALCULATOR_LAUNCH_TIMEOUT_MS = 60_000;
/** The auto-approval preview and a manual run evaluate every stage; the gateway allows 60 s. */
export const AUTO_APPROVAL_TIMEOUT_MS = 60_000;

function listQuery(query: Record<string, unknown>): ApiRequest["query"] {
  const out: ApiRequest["query"] = {};
  for (const [key, value] of Object.entries(query)) {
    if (value === undefined || value === null) continue;
    if (Array.isArray(value)) {
      out[key] = value as string[];
      continue;
    }
    if (typeof value === "boolean" || typeof value === "number" || typeof value === "string") {
      out[key] = value;
    }
  }
  return out;
}

export type TaxApiClient = ReturnType<typeof createTaxApiClient>;

/** The file of a calculator request: its staged upload when there is one, else inline base64. */
function lotFileSource(
  contentBase64: string,
  stagedUploadId: string | undefined,
): { contentBase64: string } | { stagedUploadId: string } {
  return stagedUploadId ? { stagedUploadId } : { contentBase64 };
}

export function createTaxApiClient(options: {
  transport: Transport;
  newIdempotencyKey?: () => string;
}) {
  return guardResponseShape(buildTaxApiClient(options));
}

function isSchemaError(error: unknown): boolean {
  return error instanceof Error && error.name === "ZodError";
}

function asUnexpectedResponse(error: unknown): unknown {
  if (error instanceof TaxApiError || !isSchemaError(error)) return error;
  // A 2xx the screen cannot read (older API, proxy rewrite) is a plain-language
  // failure with a retry, never a raw schema dump.
  return unexpectedResponseError(error);
}

/**
 * Every response is validated against its contract schema inside the client.
 * A mismatch throws a ZodError whose message is a JSON dump; screens would
 * print it. Convert it once, here, into a `TaxApiError` the screens can explain.
 */
function guardResponseShape<T extends object>(client: T): T {
  const guarded: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(client)) {
    if (typeof value !== "function") {
      guarded[key] = value;
      continue;
    }
    guarded[key] = (...args: unknown[]) => {
      try {
        const result = (value as (...inner: unknown[]) => unknown)(...args);
        return result instanceof Promise
          ? result.catch((error: unknown) => {
              throw asUnexpectedResponse(error);
            })
          : result;
      } catch (error) {
        throw asUnexpectedResponse(error);
      }
    };
  }
  return guarded as T;
}

function buildTaxApiClient(options: {
  transport: Transport;
  newIdempotencyKey?: () => string;
}) {
  const { transport } = options;
  const newIdempotencyKey = options.newIdempotencyKey ?? newCorrelationId;

  async function get<T>(
    path: string,
    query?: ApiRequest["query"],
    signal?: AbortSignal,
    timeoutMs?: number,
    organizationId?: string,
  ) {
    const result = await transport({
      method: "GET",
      path,
      query,
      signal,
      timeoutMs,
      organizationId,
    });
    return result.body as T;
  }

  async function getParsed<T>(
    schema: { parse: (value: unknown) => T },
    path: string,
    query?: ApiRequest["query"],
    signal?: AbortSignal,
    timeoutMs?: number,
    organizationId?: string,
  ) {
    return schema.parse(await get<unknown>(path, query, signal, timeoutMs, organizationId));
  }

  async function getBinary(
    path: string,
    query?: ApiRequest["query"],
    signal?: AbortSignal,
    timeoutMs?: number,
  ): Promise<ArrayBuffer> {
    const result = await transport({
      method: "GET",
      path,
      query,
      signal,
      timeoutMs,
      responseType: "arrayBuffer",
    });
    if (!(result.body instanceof ArrayBuffer)) {
      throw new TypeError("The artifact download response was not binary");
    }
    return result.body;
  }

  async function mutate<T>(
    method: Extract<ApiRequest["method"], "POST" | "PATCH" | "PUT" | "DELETE">,
    path: string,
    body?: unknown,
    idempotencyKey?: string,
    organizationId?: string,
    ifMatch?: number,
    timeoutMs?: number,
    signal?: AbortSignal,
  ) {
    const result = await mutateResult(
      method,
      path,
      body,
      idempotencyKey,
      organizationId,
      ifMatch,
      timeoutMs,
      signal,
    );
    return result.body as T;
  }

  /** `mutate` with the HTTP status, for the routes whose 200 and 202 mean different things. */
  async function mutateResult(
    method: Extract<ApiRequest["method"], "POST" | "PATCH" | "PUT" | "DELETE">,
    path: string,
    body?: unknown,
    idempotencyKey?: string,
    organizationId?: string,
    ifMatch?: number,
    timeoutMs?: number,
    signal?: AbortSignal,
  ) {
    // One key for every replay: when the gateway times out a write that the
    // server completed, asking again returns that result instead of a duplicate.
    const key = idempotencyKey ?? newIdempotencyKey();
    const send = () =>
      transport({
        method,
        path,
        body,
        idempotencyKey: key,
        organizationId,
        ifMatch,
        ...(timeoutMs ? { timeoutMs } : {}),
        ...(signal ? { signal } : {}),
      });
    // Idempotency is per route: only verified routes are replayed after a lost answer.
    return isIdempotentReplayAllowed(method, path)
      ? await withCommitVerification(send)
      : await send();
  }

  return {
    bulkTriageMax: BULK_TRIAGE_MAX,
    ...productCatalogMethods(transport),
    ...productImageMethods(transport),

    getSession: (signal?: AbortSignal) =>
      get<Session>("/v1/session", undefined, signal, SESSION_REQUEST_TIMEOUT_MS),

    getSessionReplayConfig: (signal?: AbortSignal) =>
      getParsed(sessionReplayConfigSchema, "/v1/session-replay/config", undefined, signal),

    uploadSessionReplayChunk: async (
      body: SessionReplayChunkRequest,
      options?: { keepalive?: boolean },
    ) => {
      const result = await transport({
        method: "POST",
        path: "/v1/session-replays/chunks",
        body,
        idempotencyKey: body.chunkId,
        ...(options?.keepalive ? { keepalive: true } : {}),
      });
      return sessionReplayChunkResponseSchema.parse(result.body);
    },

    listMcpTools: (signal?: AbortSignal) =>
      getParsed(taxMcpCatalogSchema, "/v1/mcp/tools", undefined, signal),

    listPasskeys: (signal?: AbortSignal) =>
      getParsed(passkeyCredentialListSchema, "/v1/auth/passkeys", undefined, signal),

    createPasskeyRegistrationOptions: () =>
      mutate<unknown>("POST", "/v1/auth/passkeys/register/options", {}),

    verifyPasskeyRegistration: async (input: unknown) =>
      passkeyCredentialSchema.parse(
        await mutate<unknown>("POST", "/v1/auth/passkeys/register/verify", input),
      ),

    deletePasskey: (passkeyId: string) => mutate<null>("DELETE", `/v1/auth/passkeys/${passkeyId}`),

    listPrincipalAccess: (signal?: AbortSignal) =>
      get<PrincipalAccessRecord[]>("/v1/principals", undefined, signal),

    listIntegrationKeys: (signal?: AbortSignal, organizationId?: string) =>
      get<IntegrationKeyMetadata[]>(
        "/v1/integration-keys",
        undefined,
        signal,
        undefined,
        organizationId,
      ),

    listIntegrationRequests: (
      query: IntegrationRequestQuery,
      signal?: AbortSignal,
      organizationId?: string,
    ) =>
      getParsed(
        integrationRequestAttemptPageSchema,
        "/v1/integration-requests",
        listQuery(query),
        signal,
        undefined,
        organizationId,
      ),

    createIntegrationKey: (input: IntegrationKeyWrite, idempotencyKey?: string) =>
      mutate<IntegrationKeySecretResponse>(
        "POST",
        "/v1/integration-keys",
        input,
        idempotencyKey,
        input.organizationId,
      ),

    rotateIntegrationKey: (
      input: { keyId: string; rotation: IntegrationKeyRotate; organizationId?: string },
      idempotencyKey?: string,
    ) =>
      mutate<IntegrationKeySecretResponse>(
        "POST",
        `/v1/integration-keys/${input.keyId}:rotate`,
        input.rotation,
        idempotencyKey,
        input.organizationId,
      ),

    revokeIntegrationKey: (
      input: { keyId: string; revoke: IntegrationKeyRevoke; organizationId?: string },
      idempotencyKey?: string,
    ) =>
      mutate<IntegrationKeySecretResponse>(
        "POST",
        `/v1/integration-keys/${input.keyId}:revoke`,
        input.revoke,
        idempotencyKey,
        input.organizationId,
      ),

    createPrincipalAccess: (input: PrincipalAccessWrite) =>
      mutate<PrincipalAccessRecord>("POST", "/v1/principals", input),

    updatePrincipalAccess: (input: { id: string; access: PrincipalAccessWrite }) =>
      mutate<PrincipalAccessRecord>("PATCH", `/v1/principals/${input.id}`, input.access),

    resendPrincipalInvite: (id: string) => mutate<void>("POST", `/v1/principals/${id}/invite`),

    getOverview: (signal?: AbortSignal) => get<OverviewSummary>("/v1/overview", undefined, signal),

    listEvidence: (query: EvidenceQuery, signal?: AbortSignal) =>
      get<CursorPageResult<EvidenceListItem>>("/v1/evidence", listQuery(query), signal),

    getEvidence: (evidenceId: string, signal?: AbortSignal) =>
      get<EvidenceDetail>(`/v1/evidence/${evidenceId}`, undefined, signal),

    getEvidenceArtifact: (
      evidenceId: string,
      input: {
        kind?: "normalized";
        offset?: number;
        /** Code-point start (locator unit); replaces `offset`. */
        charOffset?: number;
        limit?: number;
        locatorOffset?: number;
        locatorLimit?: number;
      } = {},
      signal?: AbortSignal,
    ) =>
      get<EvidenceArtifactPage>(
        `/v1/evidence/${evidenceId}/artifact`,
        listQuery({
          kind: input.kind ?? "normalized",
          ...(input.charOffset === undefined
            ? { offset: input.offset ?? 0 }
            : { charOffset: input.charOffset }),
          limit: input.limit,
          locatorOffset: input.locatorOffset,
          locatorLimit: input.locatorLimit,
        }),
        signal,
      ),

    downloadEvidenceArtifact: (evidenceId: string, signal?: AbortSignal) =>
      getBinary(`/v1/evidence/${evidenceId}/artifact`, { kind: "raw" }, signal),

    admitCommercialFiscalExtract: async (
      body: CommercialFiscalExtractRequest,
      idempotencyKey?: string,
    ) =>
      commercialFiscalExtractResultSchema.parse(
        await mutate("POST", "/v1/evidence/workbook-extracts", body, idempotencyKey),
      ),
    getCommercialFiscalExtract: (id: string, signal?: AbortSignal) =>
      getParsed(
        commercialFiscalExtractResultSchema,
        `/v1/evidence/workbook-extracts/${id}`,
        undefined,
        signal,
      ),
    createWorkbookRowDrafts: async (
      extractId: string,
      body: WorkbookRowDraftRequest,
      idempotencyKey?: string,
    ) =>
      workbookRowDraftBatchResultSchema.parse(
        await mutate(
          "POST",
          `/v1/evidence/workbook-extracts/${extractId}/row-drafts`,
          body,
          idempotencyKey,
        ),
      ),
    listWorkbookRowDrafts: (extractId: string, signal?: AbortSignal) =>
      getParsed(
        workbookRowDraftListSchema,
        `/v1/evidence/workbook-extracts/${extractId}/row-drafts`,
        undefined,
        signal,
      ),
    getWorkbookRowDraft: (draftId: string, signal?: AbortSignal) =>
      getParsed(
        workbookRowDraftDetailSchema,
        `/v1/workbook-row-drafts/${draftId}`,
        undefined,
        signal,
      ),
    linkWorkbookRowDraftEvidence: async (
      draftId: string,
      body: WorkbookRowDraftEvidenceLinkRequest,
      idempotencyKey?: string,
    ) =>
      workbookRowDraftEvidenceLinkResultSchema.parse(
        await mutate(
          "POST",
          `/v1/workbook-row-drafts/${draftId}/evidence-links`,
          body,
          idempotencyKey,
        ),
      ),
    listEvidenceTasks: (query: EvidenceTaskQuery = {}, signal?: AbortSignal) =>
      getParsed(evidenceTaskPageSchema, "/v1/evidence-tasks", listQuery(query), signal),

    getEvidenceTask: (taskId: string, signal?: AbortSignal) =>
      getParsed(evidenceTaskSchema, `/v1/evidence-tasks/${taskId}`, undefined, signal),

    listEvidenceTaskAssignees: (signal?: AbortSignal) =>
      getParsed(evidenceTaskAssigneePageSchema, "/v1/evidence-tasks/assignees", undefined, signal),

    createEvidenceTask: (input: EvidenceTaskCreate, idempotencyKey?: string) =>
      mutate<EvidenceTask>("POST", "/v1/evidence-tasks", input, idempotencyKey),

    updateEvidenceTask: (input: {
      taskId: string;
      patch: EvidenceTaskPatch;
      revision: number;
      idempotencyKey?: string;
    }) =>
      mutate<EvidenceTask>(
        "PATCH",
        `/v1/evidence-tasks/${input.taskId}`,
        input.patch,
        input.idempotencyKey,
        undefined,
        input.revision,
      ),

    reviewEvidence: (input: { evidenceId: string; decision: EvidenceDecision; reason: string }) =>
      mutate<EvidenceDetail>("POST", `/v1/evidence/${input.evidenceId}/review`, {
        decision: input.decision,
        reason: input.reason,
      }),

    bulkReviewEvidence: (input: EvidenceBulkRequest) => {
      if (input.evidenceIds.length > BULK_TRIAGE_MAX) {
        // Fail before the request leaves the browser so the operator sees the
        // cap as a UI rule rather than a server rejection.
        return Promise.reject(
          new RangeError(`Bulk triage is capped at ${BULK_TRIAGE_MAX} documents`),
        );
      }
      return mutate<EvidenceBulkResult>("POST", "/v1/evidence/bulk-review", input);
    },

    listProposals: (query: ProposalQuery, signal?: AbortSignal) =>
      get<CursorPageResult<RuleProposalListItem>>("/v1/rule-proposals", listQuery(query), signal),

    getProposal: (proposalId: string, signal?: AbortSignal) =>
      get<RuleProposalDetail>(`/v1/rule-proposals/${proposalId}`, undefined, signal),

    getPublishedRuleMatches: (proposalId: string, signal?: AbortSignal) =>
      getParsed<PublishedRuleMatching>(
        publishedRuleMatchingSchema,
        `/v1/rule-proposals/${proposalId}/published-matches`,
        undefined,
        signal,
      ),

    createProposal: async (input: CreateRuleProposalRequest) => {
      // Creation returns the governance write model; fetch the canonical
      // console read model before navigating so live and mock transports expose
      // the exact same detail shape.
      const created = await mutate<{ id: string }>("POST", "/v1/rule-proposals", input);
      return get<RuleProposalDetail>(`/v1/rule-proposals/${created.id}`);
    },

    decideProposal: (input: {
      proposalId: string;
      decision: "APPROVED" | "REJECTED";
      reason: string;
    }) =>
      mutate<RuleProposalDetail>("POST", `/v1/rule-proposals/${input.proposalId}/decision`, {
        decision: input.decision,
        reason: input.reason,
      }),

    /**
     * A reviewed proposal plan: DRY_RUN reads only; COMMIT (with the dry run's
     * plan hash) creates PENDING_REVIEW proposals for the NEW items. Never
     * approves or publishes. CREATE:TAX_RULE:ALL.
     */
    importProposalPlan: async (input: {
      mode: ProposalPlanImportMode;
      plan: ProposalPlan;
      expectedPlanHash?: string;
      additionalEvidenceIds?: string[];
      reason?: string;
    }) =>
      proposalPlanImportResultSchema.parse(
        await mutate<unknown>("POST", "/v1/rule-proposals:import-plan", {
          schemaVersion: "1.0.0",
          mode: input.mode,
          plan: input.plan,
          ...(input.expectedPlanHash ? { expectedPlanHash: input.expectedPlanHash } : {}),
          additionalEvidenceIds: input.additionalEvidenceIds ?? [],
          ...(input.reason ? { reason: input.reason } : {}),
        }),
      ),

    /** Read only: the active published ruleset content, the input of the plan scripts. */
    exportActiveRuleset: (signal?: AbortSignal) =>
      getParsed(activeRulesetExportSchema, "/v1/rulesets/active/export", undefined, signal),

    listCalculationRulesets: (query: CalculationRulesetOptionsQuery = {}, signal?: AbortSignal) =>
      getParsed(
        calculationRulesetOptionsPageSchema,
        "/v1/calculations/ruleset-options",
        listQuery(query),
        signal,
      ),

    listRulesets: (query: RulesetQuery, signal?: AbortSignal) =>
      get<CursorPageResult<RulesetListItem>>("/v1/rulesets", listQuery(query), signal),

    getRuleset: (rulesetId: string, signal?: AbortSignal) =>
      get<RulesetDetail>(`/v1/rulesets/${rulesetId}`, undefined, signal),

    getRulesetDiff: (input: { from: string; to: string }, signal?: AbortSignal) =>
      get<RulesetDiff>("/v1/rulesets/diff", { from: input.from, to: input.to }, signal),

    publishRuleset: (input: PublishRulesetRequest) =>
      mutate<RulesetDetail>("POST", `/v1/rulesets/${input.rulesetId}/publish`, {
        expectedDigest: input.expectedDigest,
        reason: input.reason,
      }),

    simulateOperation: async (input: OperationSimulationRequest) =>
      operationSimulationResponseSchema.parse(
        await mutate<unknown>("POST", "/v1/operations/simulate", input),
      ),
    simulateOperationWithResearch: async (input: OperationSimulationRequest) =>
      operationSimulationResponseSchema.parse(
        (
          await transport({
            method: "POST",
            path: "/v1/operations/simulate",
            body: input,
            idempotencyKey: newIdempotencyKey(),
            operationResearchVersion: "1.0.0",
          })
        ).body,
      ),
    getOperationResearch: (snapshotId: string, signal?: AbortSignal) =>
      getParsed(
        operationResearchStateSchema,
        `/v1/operations/${snapshotId}/research`,
        undefined,
        signal,
      ),
    recalculateOperation: async (snapshotId: string, rulesetVersion: string) =>
      operationSimulationResponseSchema.parse(
        await mutate<unknown>("POST", `/v1/operations/${snapshotId}/recalculate`, {
          schemaVersion: "1.0.0",
          rulesetVersion,
        }),
      ),

    setRulesetPolicy: (input: {
      rulesetId: string;
      policyVersion: TaxPolicyVersion;
      reason: string;
      revision: number;
    }) =>
      mutate<RulesetDetail>(
        "POST",
        `/v1/rulesets/${input.rulesetId}/policy`,
        { policyVersion: input.policyVersion, reason: input.reason },
        undefined,
        undefined,
        input.revision,
      ),

    /** ADR 0011: the next DRAFT ruleset with a chosen policy (PUBLISH:TAX_RULE:ALL). */
    createNextDraftRuleset: (input: { policyVersion: TaxPolicyVersionId; reason: string }) =>
      mutate<RulesetDetail>("POST", "/v1/rulesets/drafts", {
        schemaVersion: "1.0.0",
        policyVersion: input.policyVersion,
        reason: input.reason,
      }),

    getPolicyReadiness: (
      rulesetId: string,
      policyVersion: TaxPolicyVersionId,
      signal?: AbortSignal,
    ) =>
      getParsed(
        policyReadinessSchema,
        `/v1/rulesets/${rulesetId}/policy-readiness`,
        { policyVersion },
        signal,
      ),

    createIpiRestatements: async (
      rulesetId: string,
      body: Omit<IpiRestatementRequest, "schemaVersion">,
    ) =>
      ipiRestatementResultSchema.parse(
        await mutate<unknown>("POST", `/v1/rulesets/${rulesetId}/ipi-restatements`, {
          schemaVersion: "1.0.0",
          ...body,
        }),
      ),

    /** ADR 0013 §4: proposal drafts from certified facts (never proposals). */
    proposeRulesFromFacts: async (selector: FactProposalRequest["selector"]) =>
      factProposalResultSchema.parse(
        await mutate<unknown>("POST", "/v1/fiscal-facts/rule-proposal-drafts", {
          schemaVersion: "1.0.0",
          selector,
        }),
      ),

    listRuleProposalDrafts: (
      query: {
        rulesetId?: string;
        status?: RuleProposalDraftStatus[];
        origin?: RuleProposalDraftOrigin[];
        cursor?: string | null;
        limit?: number;
      },
      signal?: AbortSignal,
    ) =>
      getParsed(
        ruleProposalDraftPageSchema,
        "/v1/rule-proposal-drafts",
        listQuery({
          ...query,
          status: query.status?.join(","),
          origin: query.origin?.join(","),
        }),
        signal,
      ),

    submitRuleProposalDraft: async (
      draftId: string,
      body: Omit<RuleProposalDraftSubmit, "schemaVersion">,
      revision: number,
    ) =>
      ruleProposalDraftSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/rule-proposal-drafts/${draftId}/submit`,
          { schemaVersion: "1.0.0", ...body },
          undefined,
          undefined,
          revision,
        ),
      ),

    discardRuleProposalDraft: async (draftId: string, reason: string, revision: number) =>
      ruleProposalDraftSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/rule-proposal-drafts/${draftId}/discard`,
          { schemaVersion: "1.0.0", reason },
          undefined,
          undefined,
          revision,
        ),
      ),

    rollbackRuleset: (input: RollbackRulesetRequest) =>
      mutate<RulesetDetail>("POST", "/v1/rulesets/rollback", {
        targetRulesetId: input.targetRulesetId,
        reason: input.reason,
      }),

    listRules: (query: RuleQuery, signal?: AbortSignal) =>
      get<CursorPageResult<RuleListItem>>("/v1/rules", listQuery(query), signal),

    listNcmCatalog: (query: NcmCatalogQuery, signal?: AbortSignal) =>
      getParsed(integrationNcmCatalogPageSchema, "/v1/ncm-catalog", listQuery(query), signal),

    /** Product → NCM search (reference only). `lang` is the reader's language. */
    searchNcm: (
      query: { q: string; lang: NcmSearchLanguage; limit?: number },
      signal?: AbortSignal,
    ) => getParsed(ncmSearchResponseSchema, "/v1/ncm/search", listQuery(query), signal),

    /** `code` is the 8-digit NCM, digits only. */
    getNcm: (code: string, lang: NcmSearchLanguage, signal?: AbortSignal) =>
      getParsed(ncmDetailResponseSchema, `/v1/ncm/${code}`, { lang }, signal),

    /** Official descriptions for up to 200 codes in one request. */
    describeNcms: (codes: readonly string[], lang: NcmSearchLanguage, signal?: AbortSignal) =>
      getParsed(
        ncmDescriptionsResponseSchema,
        "/v1/ncm/descriptions",
        { codes: codes.join(","), lang },
        signal,
      ),

    listCestCatalog: (
      query: { cest?: string; q?: string; limit?: number; cursor?: string | null },
      signal?: AbortSignal,
    ) => getParsed(integrationCestCatalogPageSchema, "/v1/cest-catalog", listQuery(query), signal),

    getChapterIllustration: (chapter: string, signal?: AbortSignal) =>
      getParsed(
        ncmChapterIllustrationSchema,
        `/v1/ncm-chapters/${chapter}/illustration`,
        undefined,
        signal,
      ),

    ensureChapterIllustration: async (chapter: string) =>
      ncmChapterIllustrationSchema.parse(
        await mutate<unknown>("POST", `/v1/ncm-chapters/${chapter}/illustration`, {}),
      ),

    /**
     * A calculator file over the inline limit goes to Cloud Storage directly (API Gateway and Cloud
     * Run cap a request at 32 MB). Opens an upload session, PUTs the bytes to it and returns the id
     * the inspect, repair and import calls then send instead of `contentBase64`. A deployment
     * without direct uploads (the demo) answers 501 OPERATION_NOT_AVAILABLE.
     */
    stageLotFile: async (file: Blob & { name: string }, signal?: AbortSignal) => {
      const session = lotUploadSessionSchema.parse(
        await mutate<unknown>("POST", "/v1/calculations/upload-sessions", {
          filename: file.name,
          sizeBytes: file.size,
        }),
      );
      const response = await fetch(session.uploadUrl, {
        method: session.method,
        headers: { "content-type": "application/octet-stream" },
        body: file,
        ...(signal ? { signal } : {}),
      });
      if (!response.ok) {
        throw new TaxApiError({
          code: "DEPENDENCY_UNAVAILABLE",
          status: response.status === 0 ? 503 : response.status,
          message: "The file could not be uploaded to storage; try again",
          retryable: true,
          method: "PUT",
          path: "/v1/calculations/upload-sessions",
        });
      }
      return { stagedUploadId: session.stagedUploadId };
    },
    inspectLot: async (
      filename: string,
      contentBase64: string,
      stagedUploadId?: string,
      templateProfile?: "JAMERSON_V1",
    ) =>
      lotInspectionSchema.parse(
        await mutate<unknown>("POST", "/v1/calculations/inspect", {
          filename,
          ...(templateProfile ? { templateProfile } : {}),
          ...lotFileSource(contentBase64, stagedUploadId),
        }),
      ),
    /** Read-only: what the converter would block on this sheet and what could mend it. Nothing is stored. */
    suggestLotRepairs: async (input: {
      filename: string;
      contentBase64: string;
      /** The staged upload of a file over the inline limit; replaces contentBase64. */
      stagedUploadId?: string;
      mapping: LotMapping;
      route?: LotRoute;
      previewContext?: LotRepairSuggestionRequest["previewContext"];
      repairs?: LotRepairSuggestionRequest["repairs"];
    }) =>
      lotRepairSuggestionsSchema.parse(
        await mutate<unknown>("POST", "/v1/calculations/repair-suggestions", {
          filename: input.filename,
          ...lotFileSource(input.contentBase64, input.stagedUploadId),
          mapping: input.mapping,
          ...(input.route ? { route: input.route } : {}),
          ...(input.previewContext ? { previewContext: input.previewContext } : {}),
          ...(input.repairs?.length ? { repairs: input.repairs } : {}),
        }),
      ),
    importLot: async (
      filename: string,
      contentBase64: string,
      mapping?: LotMapping,
      options?: {
        /** The route of the whole file: one UF pair, or each row's own. */
        workbookId?: string;
        route?: LotRoute;
        /** What to do about routes with no rule. Stored with the upload; defaults to ASK server-side. */
        researchMissing?: ResearchMissing;
        /** Repairs the person confirmed for this sheet; recorded on the upload receipt. */
        repairs?: readonly LotRepair[];
        /** Reuse the same key to replay an import instead of storing the file twice. */
        idempotencyKey?: string;
        /** The staged upload of a file over the inline limit; replaces contentBase64. */
        stagedUploadId?: string;
      },
    ) =>
      lotUploadSchema.parse(
        await mutate<unknown>(
          "POST",
          "/v1/calculations/import",
          {
            filename,
            ...lotFileSource(contentBase64, options?.stagedUploadId),
            ...(options?.workbookId ? { workbookId: options.workbookId } : {}),
            ...(mapping ? { mapping } : {}),
            ...(options?.route ? { route: options.route } : {}),
            ...(options?.researchMissing ? { researchMissing: options.researchMissing } : {}),
            ...(mapping && options?.repairs?.length ? { repairs: options.repairs } : {}),
          },
          options?.idempotencyKey,
          undefined,
          undefined,
          CALCULATOR_LAUNCH_TIMEOUT_MS,
        ),
      ),

    /** Which origin, destination and NCM combinations a lot needs, and whether the ruleset covers them. */
    getCalculationCoverage: async (input: CalculationCoverageRequest) =>
      calculationCoverageReportSchema.parse(
        await mutate<unknown>(
          "POST",
          "/v1/calculations/coverage",
          input,
          undefined,
          undefined,
          undefined,
          CALCULATOR_LAUNCH_TIMEOUT_MS,
        ),
      ),

    /** Administração → Custo estimado da infraestrutura (platform admins; an estimate, not an invoice). */
    getInfraCostEstimate: (signal?: AbortSignal) =>
      getParsed(infraCostEstimateSchema, "/v1/infra-cost", undefined, signal),

    /* -- Autoaprovação (ADR 0020) --------------------------------------------- */

    getAutoApprovalSettings: (signal?: AbortSignal) =>
      getParsed(autoApprovalSettingsSchema, "/v1/auto-approval/settings", undefined, signal),

    updateAutoApprovalSettings: async (update: AutoApprovalSettingsUpdate, revision: number) =>
      autoApprovalSettingsSchema.parse(
        await mutate<unknown>(
          "PUT",
          "/v1/auto-approval/settings",
          update,
          undefined,
          undefined,
          revision,
        ),
      ),

    getAutoApprovalPackage: (signal?: AbortSignal) =>
      getParsed(autoApprovalPackageStatusSchema, "/v1/auto-approval/package", undefined, signal),

    getAutoApprovalPreview: (signal?: AbortSignal, scenario: "current" | "all" = "current") =>
      getParsed(
        autoApprovalPreviewSchema,
        "/v1/auto-approval/preview",
        scenario === "all" ? { scenario: "all" } : undefined,
        signal,
        AUTO_APPROVAL_TIMEOUT_MS,
      ),

    runAutoApproval: async (idempotencyKey?: string) =>
      autoApprovalRunSchema.parse(
        await mutate<unknown>(
          "POST",
          "/v1/auto-approval/runs",
          { schemaVersion: "1.0.0" },
          idempotencyKey,
          undefined,
          undefined,
          AUTO_APPROVAL_TIMEOUT_MS,
        ),
      ),

    listAutoApprovalRuns: (signal?: AbortSignal) =>
      getParsed(
        z.object({
          schemaVersion: z.literal("1.0.0"),
          items: z.array(autoApprovalRunSchema),
        }),
        "/v1/auto-approval/runs",
        undefined,
        signal,
      ),

    getAutoApprovalReport: (date: string, signal?: AbortSignal) =>
      getParsed(autoApprovalReportSchema, "/v1/auto-approval/report", listQuery({ date }), signal),
    /** Agentes → Pesquisa web: daily autonomous research scheduler (platform admins). */
    getAutonomousResearch: (signal?: AbortSignal) =>
      getParsed(autonomousResearchOverviewSchema, "/v1/autonomous-research", undefined, signal),
    getArgonSyntheticEligibility: (signal?: AbortSignal) =>
      getParsed(
        argonSyntheticEligibilitySchema,
        "/v1/web-research/synthetic-acceptances/eligibility",
        undefined,
        signal,
      ),
    admitArgonSyntheticAcceptance: async (input: ArgonSyntheticAdmission, idempotencyKey: string) =>
      argonSyntheticAcceptanceSchema.parse(
        await mutate<unknown>(
          "POST",
          "/v1/web-research/synthetic-acceptances",
          argonSyntheticAdmissionSchema.parse(input),
          idempotencyKey,
        ),
      ),
    getCommercialDriveWatch: (signal?: AbortSignal) =>
      getParsed(
        commercialDriveWatchOverviewSchema,
        "/v1/commercial-drive-watch",
        undefined,
        signal,
      ),
    listCommercialDriveWatchFiles: (
      query: { runId: string; afterFileId?: string; limit?: number },
      signal?: AbortSignal,
    ) =>
      getParsed(commercialDriveWatchFilesSchema, "/v1/commercial-drive-watch/files", query, signal),

    getAutonomousResearchScope: (
      query: Partial<AutonomousResearchScopeQuery> = {},
      signal?: AbortSignal,
    ) =>
      getParsed(
        autonomousResearchScopeSchema,
        "/v1/autonomous-research/scope",
        listQuery(query),
        signal,
      ),

    /** Administração → Planilhas com erro: failed calculator uploads (platform admins). */
    listUploadFailures: (query: UploadFailureQuery, signal?: AbortSignal) =>
      getParsed(
        uploadFailurePageSchema,
        "/v1/calculation-upload-failures",
        listQuery(query),
        signal,
      ),
    getUploadFailure: (failureId: string, signal?: AbortSignal) =>
      getParsed(
        uploadFailureDetailSchema,
        `/v1/calculation-upload-failures/${failureId}`,
        undefined,
        signal,
      ),
    /** The original bytes; only answered while `original.status` is STORED. */
    downloadUploadFailureFile: (failureId: string) =>
      getBinary(`/v1/calculation-upload-failures/${failureId}/file`),
    reviewUploadFailure: async (failureId: string, input: UploadFailureReviewRequest) =>
      uploadFailureDetailSchema.parse(
        await mutate<unknown>("POST", `/v1/calculation-upload-failures/${failureId}/review`, input),
      ),

    /** Administração → Sessões: recorded operator sessions, newest first. */
    listSessionReplays: (query: SessionReplayQuery, signal?: AbortSignal) =>
      getParsed(sessionReplayPageSchema, "/v1/session-replays", listQuery(query), signal),
    getSessionReplay: (replaySessionId: string, signal?: AbortSignal) =>
      getParsed(
        sessionReplayDetailSchema,
        `/v1/session-replays/${replaySessionId}`,
        undefined,
        signal,
      ),
    listSessionReplayEvents: (
      replaySessionId: string,
      query: { fromSequence?: number; maxChunks?: number },
      signal?: AbortSignal,
    ) =>
      getParsed(
        sessionReplayEventsPageSchema,
        `/v1/session-replays/${replaySessionId}/events`,
        listQuery(query),
        signal,
      ),
    /** Activity inside one session, oldest first. */
    listSessionReplayActivity: (
      replaySessionId: string,
      query: { cursor?: string; limit?: number },
      signal?: AbortSignal,
    ) =>
      getParsed(
        sessionActivityPageSchema,
        `/v1/session-replays/${replaySessionId}/activity`,
        listQuery(query),
        signal,
      ),
    /** Activity across sessions, newest first. */
    listSessionActivity: (query: SessionActivityQuery, signal?: AbortSignal) =>
      getParsed(sessionActivityPageSchema, "/v1/session-activity", listQuery(query), signal),
    lookupSessionReplay: (query: SessionReplayLookupQuery, signal?: AbortSignal) =>
      getParsed(sessionReplayLookupSchema, "/v1/session-replay-lookup", listQuery(query), signal),
    getSessionReplaySettings: (signal?: AbortSignal) =>
      getParsed(sessionReplaySettingsSchema, "/v1/session-replay/settings", undefined, signal),
    updateSessionReplaySettings: async (input: SessionReplaySettingsUpdate) =>
      sessionReplaySettingsSchema.parse(
        await mutate<unknown>("PUT", "/v1/session-replay/settings", input),
      ),

    getLotUpload: (id: string) => getParsed(lotUploadSchema, `/v1/calculations/uploads/${id}`),
    downloadLotUpload: (id: string) => getBinary(`/v1/calculations/uploads/${id}/file`),
    createUploadedLotTask: async (
      id: string,
      input: UploadedLotTaskRequest,
      idempotencyKey?: string,
    ) =>
      fiscalTaskSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/calculations/uploads/${id}/tasks`,
          input,
          idempotencyKey,
          undefined,
          undefined,
          CALCULATOR_LAUNCH_TIMEOUT_MS,
        ),
      ),
    /**
     * "Calcular N abas": the first task of an upload imported and never calculated. `existing` when
     * the upload already had one (200): nothing new was started.
     */
    createFirstUploadedLotTask: async (
      id: string,
      input: UploadedLotTaskRequest,
      idempotencyKey?: string,
    ) => {
      const result = await mutateResult(
        "POST",
        `/v1/calculations/uploads/${id}/tasks`,
        { ...input, firstCalculation: true },
        idempotencyKey,
        undefined,
        undefined,
        CALCULATOR_LAUNCH_TIMEOUT_MS,
      );
      return { task: fiscalTaskSchema.parse(result.body), existing: result.status === 200 };
    },
    /** "Confirmar perfil PIS/COFINS": the upload's recorded confirmations, oldest first. */
    listLotInputCorrections: (uploadId: string, signal?: AbortSignal) =>
      getParsed(
        lotInputCorrectionListSchema,
        `/v1/calculations/uploads/${uploadId}/input-corrections`,
        undefined,
        signal,
      ),
    createLotInputCorrection: async (
      uploadId: string,
      input: LotInputCorrectionRequest,
      idempotencyKey?: string,
    ) =>
      lotInputCorrectionSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/calculations/uploads/${uploadId}/input-corrections`,
          input,
          idempotencyKey,
        ),
      ),
    simulateLot: async (input: LotSimulationRequest, idempotencyKey?: string) =>
      lotSimulationResponseSchema.parse(
        await mutate<unknown>("POST", "/v1/calculations/simulate", input, idempotencyKey),
      ),

    listCalculations: (query: CalculationQuery, signal?: AbortSignal) =>
      get<CursorPageResult<CalculationListItem>>("/v1/calculations", listQuery(query), signal),

    getCalculationJobSummary: (query: { from?: string; to?: string }, signal?: AbortSignal) =>
      getParsed(calculationJobSummarySchema, "/v1/calculation-jobs/summary", query, signal),

    listCalculationJobs: (query: CalculationJobQuery, signal?: AbortSignal) =>
      getParsed(calculationJobPageSchema, "/v1/calculation-jobs", listQuery(query), signal),

    getCalculation: (calculationId: string, signal?: AbortSignal) =>
      get<CalculationDetail>(`/v1/calculations/${calculationId}`, undefined, signal),

    getCalculationMemory: (
      input: { calculationId: string; itemId: string },
      signal?: AbortSignal,
    ) => {
      const calculationPathId = encodeURIComponent(input.calculationId);
      const itemPathId = encodeURIComponent(input.itemId);
      return getParsed(
        calculationMemorySchema,
        `/v1/calculations/${calculationPathId}/items/${itemPathId}/memory`,
        undefined,
        signal,
      );
    },

    explainCalculationItem: (
      input: { calculationId: string; itemId: string },
      signal?: AbortSignal,
    ) =>
      get<CalculationExplain>(
        `/v1/calculations/${input.calculationId}/items/${input.itemId}/explain`,
        undefined,
        signal,
      ),

    listFiscalTasks: (query: FiscalTaskQuery, signal?: AbortSignal) =>
      getParsed(fiscalTaskPageSchema, "/v1/fiscal-tasks", listQuery(query), signal),

    getFiscalTask: (taskId: string, signal?: AbortSignal) =>
      getParsed(fiscalTaskSchema, `/v1/fiscal-tasks/${taskId}`, undefined, signal),

    getSpRouteCoverage: (
      query: { direction: "ALL_TO_SP" | "SP_TO_ALL"; checkedAsOf: string; ncm?: string },
      signal?: AbortSignal,
    ) => getParsed(spRouteCoverageSchema, "/v1/coverage/sp-routes", query, signal),

    listCoverageGaps: (query: CoverageGapQuery = {}, signal?: AbortSignal) =>
      getParsed(coverageGapPageSchema, "/v1/coverage-gaps", listQuery(query), signal),

    researchCoverageGap: async (input: { gapId: string; idempotencyKey?: string }) =>
      coverageGapSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/coverage-gaps/${input.gapId}/research`,
          { schemaVersion: "1.0.0" },
          input.idempotencyKey,
        ),
      ),

    researchNextCoverageGaps: async (input: { limit: number; idempotencyKey?: string }) =>
      coverageGapBatchResearchResponseSchema.parse(
        await mutate<unknown>(
          "POST",
          "/v1/coverage-gaps/research-next",
          { schemaVersion: "1.0.0", limit: input.limit },
          input.idempotencyKey,
        ),
      ),

    recordCoverageGapFinding: async (input: {
      gapId: string;
      revision: number;
      finding: Omit<CoverageGapFindingRequest, "schemaVersion">;
    }) =>
      coverageGapSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/coverage-gaps/${input.gapId}/finding`,
          { schemaVersion: "1.0.0", ...input.finding },
          undefined,
          undefined,
          input.revision,
        ),
      ),

    dismissCoverageGap: async (input: { gapId: string; revision: number; reason: string }) =>
      coverageGapSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/coverage-gaps/${input.gapId}/dismiss`,
          { schemaVersion: "1.0.0", reason: input.reason },
          undefined,
          undefined,
          input.revision,
        ),
      ),

    /* -- Browser agent (ADR 0012): read-only spectator + stop ------------ */

    listBrowserAgentRuns: (query: BrowserAgentRunQuery = {}, signal?: AbortSignal) =>
      getParsed(browserAgentRunPageSchema, "/v1/browser-agent/runs", listQuery(query), signal),

    getBrowserAgentRun: (runId: string, signal?: AbortSignal) =>
      getParsed(browserAgentRunSchema, `/v1/browser-agent/runs/${runId}`, undefined, signal),

    /** The agent's last work poll (it polls while idle too). */
    getBrowserAgentPresence: (signal?: AbortSignal) =>
      getParsed(browserAgentPresenceSchema, "/v1/browser-agent/presence", undefined, signal),

    listBrowserAgentSteps: (runId: string, after?: number, signal?: AbortSignal) =>
      getParsed(
        browserAgentStepListSchema,
        `/v1/browser-agent/runs/${runId}/steps`,
        listQuery({ after }),
        signal,
      ),

    listBrowserAgentFindings: (query: BrowserAgentFindingQuery = {}, signal?: AbortSignal) =>
      getParsed(
        browserAgentFindingPageSchema,
        "/v1/browser-agent/findings",
        listQuery(query),
        signal,
      ),

    /** Findings per Brasília day by outcome (every day in the range). */
    getBrowserAgentFindingDaily: (from: string, to: string, signal?: AbortSignal) =>
      getParsed(
        browserAgentFindingDailySchema,
        "/v1/browser-agent/findings/daily",
        { from, to },
        signal,
      ),

    /** Frame bytes (image/jpeg). Bearer-authenticated, so never a bare <img src>. */
    getBrowserAgentFrame: (
      frame: { bucket: string; key: string; generation: string },
      signal?: AbortSignal,
    ) =>
      getBinary(
        "/v1/browser-agent/frame",
        { bucket: frame.bucket, key: frame.key, generation: frame.generation },
        signal,
      ),

    stopBrowserAgentRun: async (runId: string) =>
      browserAgentRunSchema.parse(
        await mutate<unknown>("POST", `/v1/browser-agent/runs/${runId}/stop`),
      ),

    /* -- Browser agent phase 2: settings, credentials, queue, lookup jobs -- */

    getBrowserAgentSettings: (signal?: AbortSignal) =>
      getParsed(browserAgentSettingsSchema, "/v1/browser-agent/settings", undefined, signal),

    /** Optimistic concurrency: `If-Match: "<revision>"` of the settings being edited. */
    updateBrowserAgentSettings: async (update: BrowserAgentSettingsUpdate, revision: number) =>
      browserAgentSettingsSchema.parse(
        await mutate<unknown>(
          "PUT",
          "/v1/browser-agent/settings",
          update,
          undefined,
          undefined,
          revision,
        ),
      ),

    getBrowserAgentCredentials: (signal?: AbortSignal) =>
      getParsed(
        browserAgentCredentialsStatusSchema,
        "/v1/browser-agent/credentials",
        undefined,
        signal,
      ),

    /**
     * Write-only: the password goes straight to the API (Secret Manager) and
     * only the masked status comes back. Callers must not cache the input.
     */
    updateBrowserAgentCredentials: async (update: BrowserAgentCredentialsUpdate) =>
      browserAgentCredentialsStatusSchema.parse(
        await mutate<unknown>("PUT", "/v1/browser-agent/credentials", update),
      ),

    listBrowserAgentTasks: (query: BrowserAgentTaskQuery = {}, signal?: AbortSignal) =>
      getParsed(browserAgentTaskPageSchema, "/v1/browser-agent/tasks", listQuery(query), signal),

    getBrowserAgentTask: (taskId: string, signal?: AbortSignal) =>
      getParsed(browserAgentTaskSchema, `/v1/browser-agent/tasks/${taskId}`, undefined, signal),

    listBrowserAgentTaskItems: (
      taskId: string,
      query: BrowserAgentTaskItemQuery = {},
      signal?: AbortSignal,
    ) =>
      getParsed(
        browserAgentTaskItemPageSchema,
        `/v1/browser-agent/tasks/${taskId}/items`,
        listQuery(query),
        signal,
      ),

    createBrowserAgentTask: async (input: BrowserAgentTaskCreate) =>
      browserAgentTaskSchema.parse(await mutate<unknown>("POST", "/v1/browser-agent/tasks", input)),

    actOnBrowserAgentTask: async (taskId: string, action: BrowserAgentTaskAction["action"]) =>
      browserAgentTaskSchema.parse(
        await mutate<unknown>("POST", `/v1/browser-agent/tasks/${taskId}/action`, {
          schemaVersion: "1.0.0",
          action,
        } satisfies BrowserAgentTaskAction),
      ),

    listLookupJobs: (
      query: Pick<BrowserAgentTaskQuery, "cursor" | "limit"> = {},
      signal?: AbortSignal,
    ) =>
      getParsed(taxLookupJobPageSchema, "/v1/browser-agent/lookup-jobs", listQuery(query), signal),

    getLookupJob: (jobId: string, signal?: AbortSignal) =>
      getParsed(taxLookupJobSchema, `/v1/browser-agent/lookup-jobs/${jobId}`, undefined, signal),

    /** 204. Optional jobId advances that job only; omit it to advance the lane. */
    advanceLookupJobs: (jobId?: string, signal?: AbortSignal) =>
      mutate<null>(
        "POST",
        "/v1/browser-agent/lookup-jobs:advance",
        jobId ? { jobId } : undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        signal,
      ),

    /* -- Browser agent recordings and demos ------------------------------ */

    listBrowserAgentRunRecordings: (runId: string, signal?: AbortSignal) =>
      getParsed(
        browserAgentRunRecordingsSchema,
        `/v1/browser-agent/runs/${runId}/recordings`,
        undefined,
        signal,
      ),

    /** 10-minute signed Cloud Storage URL; with `demoId`, the demo's preserved copy. */
    getBrowserAgentRecordingUrl: (recordingId: string, demoId?: string, signal?: AbortSignal) =>
      getParsed(
        browserAgentRecordingUrlSchema,
        `/v1/browser-agent/recordings/${recordingId}/url`,
        demoId ? { demoId } : undefined,
        signal,
      ),

    listBrowserAgentDemos: (query: BrowserAgentRunQuery = {}, signal?: AbortSignal) =>
      getParsed(browserAgentDemoPageSchema, "/v1/browser-agent/demos", listQuery(query), signal),

    getBrowserAgentDemo: (demoId: string, signal?: AbortSignal) =>
      getParsed(
        browserAgentDemoDetailSchema,
        `/v1/browser-agent/demos/${demoId}`,
        undefined,
        signal,
      ),

    createBrowserAgentDemo: async (input: BrowserAgentDemoCreate) =>
      browserAgentDemoSchema.parse(await mutate<unknown>("POST", "/v1/browser-agent/demos", input)),

    deleteBrowserAgentDemo: (demoId: string) =>
      mutate<null>("DELETE", `/v1/browser-agent/demos/${demoId}`),

    /* -- Web research sweeps (Administração → Pesquisa web) ---------------- */

    /** Read-only plan: NCM prefilter, units, estimated calls, cost and ETA. */
    previewResearchSweep: async (input: ResearchSweepPreviewRequest) => {
      const result = await transport({
        method: "POST",
        path: "/v1/web-research/sweeps:preview",
        query: { usageForecast: "1.0.0" },
        body: input,
        idempotencyKey: newIdempotencyKey(),
      });
      return researchSweepPreviewSchema.parse(result.body);
    },

    /** `Idempotency-Key` is required; keep one key per previewed plan so retries replay. */
    createResearchSweep: async (input: ResearchSweepCreate, idempotencyKey: string) =>
      researchSweepSchema.parse(
        await mutate<unknown>("POST", "/v1/web-research/sweeps", input, idempotencyKey),
      ),

    listResearchSweeps: (
      query: { status?: ResearchSweepStatus[]; cursor?: string | null; limit?: number } = {},
      signal?: AbortSignal,
    ) =>
      getParsed(
        researchSweepPageSchema,
        "/v1/web-research/sweeps",
        listQuery({ ...query, status: query.status?.join(",") }),
        signal,
      ),

    getResearchSweep: (sweepId: string, signal?: AbortSignal) =>
      getParsed(researchSweepSchema, `/v1/web-research/sweeps/${sweepId}`, undefined, signal),

    listResearchUnits: (
      sweepId: string,
      query: {
        kind?: ResearchUnitKind[];
        status?: ResearchUnitStatus[];
        cursor?: string | null;
        limit?: number;
      } = {},
      signal?: AbortSignal,
    ) =>
      getParsed(
        researchUnitPageSchema,
        `/v1/web-research/sweeps/${sweepId}/units`,
        listQuery({ ...query, kind: query.kind?.join(","), status: query.status?.join(",") }),
        signal,
      ),

    /** `If-Match: "<revision>"` of the sweep the operator was looking at. */
    actOnResearchSweep: async (
      sweepId: string,
      action: ResearchSweepAction["action"],
      revision: number,
    ) =>
      researchSweepSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/web-research/sweeps/${sweepId}/action`,
          { schemaVersion: "1.0.0", action } satisfies ResearchSweepAction,
          undefined,
          undefined,
          revision,
        ),
      ),

    getWebResearchSettings: (signal?: AbortSignal) =>
      getParsed(webResearchSettingsSchema, "/v1/web-research/settings", undefined, signal),

    updateWebResearchSettings: async (update: WebResearchSettingsUpdate, revision: number) =>
      webResearchSettingsSchema.parse(
        await mutate<unknown>(
          "PUT",
          "/v1/web-research/settings",
          update,
          undefined,
          undefined,
          revision,
        ),
      ),

    /* -- Fiscal facts (Regras → Verificação, ADR 0013, dormant) ------------- */

    listFiscalFacts: (
      query: {
        status?: FiscalFactStatus[];
        source?: FiscalFactSource[];
        kind?: FiscalFactKind[];
        ncm?: string;
        route?: string;
        revalidationRequested?: boolean;
        cursor?: string | null;
        limit?: number;
      } = {},
      signal?: AbortSignal,
    ) =>
      getParsed(
        fiscalFactPageSchema,
        "/v1/fiscal-facts",
        listQuery({
          ...query,
          status: query.status?.join(","),
          source: query.source?.join(","),
          kind: query.kind?.join(","),
          revalidationRequested:
            query.revalidationRequested === undefined
              ? undefined
              : String(query.revalidationRequested),
        }),
        signal,
      ),

    getFiscalFact: (factId: string, signal?: AbortSignal) =>
      getParsed(fiscalFactDetailSchema, `/v1/fiscal-facts/${factId}`, undefined, signal),

    fiscalFactQueue: (
      tab: FiscalFactQueueTab,
      query: { cursor?: string | null; limit?: number } = {},
      signal?: AbortSignal,
    ) =>
      getParsed(
        fiscalFactQueuePageSchema,
        "/v1/fiscal-facts/verification-queue",
        listQuery({ tab, ...query }),
        signal,
      ),

    /** Review groups computed server-side over every pending fact. */
    listFiscalFactReviewGroups: (
      query: Partial<FiscalFactReviewGroupQuery> & { cursor?: string | null; limit?: number },
      signal?: AbortSignal,
    ) =>
      getParsed(
        fiscalFactReviewGroupPageSchema,
        "/v1/fiscal-facts/review-groups",
        listQuery(query),
        signal,
      ),

    getFiscalFactReviewGroup: (groupId: string, signal?: AbortSignal) =>
      getParsed(
        fiscalFactReviewGroupDetailSchema,
        `/v1/fiscal-facts/review-groups/${groupId}`,
        undefined,
        signal,
      ),

    startFiscalFactReviewSession: async (groupId: string, body: FiscalFactReviewSessionStart) =>
      fiscalFactReviewSessionSchema.parse(
        await mutate<unknown>("POST", `/v1/fiscal-facts/review-groups/${groupId}/sessions`, body),
      ),

    actOnFiscalFactReviewSession: async (sessionId: string, body: FiscalFactReviewSessionAction) =>
      fiscalFactReviewSessionSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/fiscal-facts/review-sessions/${sessionId}/actions`,
          body,
        ),
      ),

    /** The session's exact scope; 409 when it changed or inspections are missing. */
    confirmFiscalFactReviewSession: async (sessionId: string, body: FiscalFactGroupConfirm) =>
      fiscalFactGroupConfirmResultSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/fiscal-facts/review-sessions/${sessionId}/confirm`,
          body,
        ),
      ),

    /** Confirmed group reviews with what their facts cover today and their corrections. */
    listFiscalFactConfirmedReviews: (
      query: { cursor?: string | null; limit?: number } = {},
      signal?: AbortSignal,
    ) =>
      getParsed(
        fiscalFactConfirmedReviewPageSchema,
        "/v1/fiscal-facts/review-sessions",
        listQuery({ ...query, status: "CONFIRMED" }),
        signal,
      ),

    /** "Corrigir escopo" of a confirmed review session (idempotent). */
    restrictFiscalFactReviewSessionScope: async (
      sessionId: string,
      body: FiscalFactScopeRestriction,
    ) =>
      fiscalFactScopeCorrectionResultSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/fiscal-facts/review-sessions/${sessionId}/scope-restriction`,
          body,
        ),
      ),

    /** "Restringir escopo de origem" on one VERIFIED fact (`If-Match: "<revision>"`). */
    restrictFiscalFactScope: async (
      factId: string,
      body: FiscalFactScopeRestriction,
      revision: number,
    ) =>
      fiscalFactScopeCorrectionResultSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/fiscal-facts/${factId}/scope-restriction`,
          body,
          undefined,
          undefined,
          revision,
        ),
      ),

    /** `If-Match: "<revision>"` of the fact on screen; 412 when it changed, 409 when not allowed. */
    verifyFiscalFact: async (factId: string, body: FiscalFactVerification, revision: number) =>
      fiscalFactSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/fiscal-facts/${factId}/verification`,
          body,
          undefined,
          undefined,
          revision,
        ),
      ),

    /** CONFAZ ST agreement matrix (observations, seed catalog, counts). */
    listStAgreements: (
      query: { status?: StAgreement["status"]; segment?: string; uf?: string } = {},
      signal?: AbortSignal,
    ) => getParsed(stAgreementPageSchema, "/v1/st-agreements", listQuery(query), signal),

    getStAgreement: (agreementId: string, signal?: AbortSignal) =>
      getParsed(stAgreementDetailSchema, `/v1/st-agreements/${agreementId}`, undefined, signal),

    /** Lists (dryRun) or rejects UNVERIFIED observations stored under a key their page does not name. */
    retireMisidentifiedStAgreements: async (body: StAgreementRetireMisidentified) =>
      stAgreementRetireMisidentifiedResultSchema.parse(
        await mutate<unknown>("POST", "/v1/st-agreements:retire-misidentified", body),
      ),

    /** `If-Match: "<revision>"`; 412 when it changed, 409 when the status does not allow it. */
    verifyStAgreement: async (
      agreementId: string,
      body: StAgreementVerification,
      revision: number,
    ) =>
      stAgreementSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/st-agreements/${agreementId}/verification`,
          body,
          undefined,
          undefined,
          revision,
        ),
      ),

    /* -- Notas fiscais: NF-e imports and observed tax paths (corroboration only) -- */

    /**
     * `POST /v1/nfe-imports` (Idempotency-Key). One request per zip, or per
     * group of loose XML files; the decoded body stays under 8 MiB. Larger
     * bodies take longer than a read, so the request gets its own timeout.
     */
    importNfeFiles: async (
      files: NfeImportRequest["files"],
      idempotencyKey: string,
      signal?: AbortSignal,
    ) => {
      const result = await transport({
        method: "POST",
        path: "/v1/nfe-imports",
        body: { schemaVersion: "1.0.0", files } satisfies NfeImportRequest,
        idempotencyKey,
        signal,
        timeoutMs: NFE_IMPORT_TIMEOUT_MS,
      });
      return nfeImportBatchDetailSchema.parse(result.body);
    },

    listNfeImports: (query: { cursor?: string | null; limit?: number }, signal?: AbortSignal) =>
      getParsed(nfeImportBatchPageSchema, "/v1/nfe-imports", listQuery(query), signal),

    getNfeImport: (batchId: string, signal?: AbortSignal) =>
      getParsed(nfeImportBatchDetailSchema, `/v1/nfe-imports/${batchId}`, undefined, signal),

    listNfeObservedPaths: (
      query: NfeObservedPathQuery & { cursor?: string | null; limit?: number },
      signal?: AbortSignal,
    ) =>
      getParsed(
        nfeObservedPathPageSchema,
        "/v1/nfe-observed-paths",
        listQuery({
          originUf: query.originUf,
          destinationUf: query.destinationUf,
          ncmPrefix: query.ncmPrefix,
          status: query.statuses?.join(","),
          cursor: query.cursor,
          limit: query.limit,
        }),
        signal,
      ),

    getNfeObservedPath: (pathId: string, signal?: AbortSignal) =>
      getParsed(nfeObservedPathDetailSchema, `/v1/nfe-observed-paths/${pathId}`, undefined, signal),

    /** Prefills one EVIDENCE_REQUIRED draft; 409 without a DRAFT ruleset or on MATCHES. */
    createNfePathDraft: async (
      pathId: string,
      body: Omit<NfePathDraftRequest, "schemaVersion">,
      idempotencyKey: string,
    ) =>
      nfePathDraftResultSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/nfe-observed-paths/${pathId}/rule-proposal-draft`,
          { schemaVersion: "1.0.0", ...body },
          idempotencyKey,
        ),
      ),

    /* -- Notas fiscais workspace: periods, findings, validation (tax managers) -- */

    getNfePeriodTree: (direction: NfeDirection | undefined, signal?: AbortSignal) =>
      getParsed(nfePeriodTreeSchema, "/v1/nfe-workspace/periods", listQuery({ direction }), signal),

    getNfePeriod: (period: string, direction: NfeDirection | undefined, signal?: AbortSignal) =>
      getParsed(
        nfePeriodDetailSchema,
        `/v1/nfe-workspace/periods/${period}`,
        listQuery({ direction }),
        signal,
      ),

    listNfeMonthPaths: (
      period: string,
      query: NfeMonthPathQuery & { cursor?: string | null; limit?: number },
      signal?: AbortSignal,
    ) =>
      getParsed(
        nfeMonthPathPageSchema,
        `/v1/nfe-workspace/periods/${period}/paths`,
        listQuery({
          direction: query.direction,
          status: query.statuses?.join(","),
          ncmPrefix: query.ncmPrefix,
          acknowledged: query.acknowledged,
          cursor: query.cursor,
          limit: query.limit,
        }),
        signal,
      ),

    getNfeMonthPath: (
      period: string,
      pathId: string,
      direction: NfeDirection | undefined,
      signal?: AbortSignal,
    ) =>
      getParsed(
        nfeMonthPathDetailSchema,
        `/v1/nfe-workspace/periods/${period}/paths/${pathId}`,
        listQuery({ direction }),
        signal,
      ),

    listNfeFindings: (
      period: string,
      query: NfeFindingQuery & { cursor?: string | null; limit?: number },
      signal?: AbortSignal,
    ) =>
      getParsed(
        nfeFindingPageSchema,
        `/v1/nfe-workspace/periods/${period}/findings`,
        listQuery({
          direction: query.direction,
          severity: query.severities?.join(","),
          source: query.source,
          code: query.code,
          acknowledged: query.acknowledged,
          status: query.status,
          cursor: query.cursor,
          limit: query.limit,
        }),
        signal,
      ),

    listNfeEvents: (
      period: string,
      query: { cursor?: string | null; limit?: number },
      signal?: AbortSignal,
    ) =>
      getParsed(
        nfePeriodEventPageSchema,
        `/v1/nfe-workspace/periods/${period}/events`,
        listQuery(query),
        signal,
      ),

    listNfeAnalysisRuns: (
      period: string,
      query: { cursor?: string | null; limit?: number },
      signal?: AbortSignal,
    ) =>
      getParsed(
        nfeAnalysisRunPageSchema,
        `/v1/nfe-workspace/periods/${period}/analysis-runs`,
        listQuery(query),
        signal,
      ),

    /** Append-only decision on a finding or a path (REVIEW:TAX_RULE:ALL). */
    acknowledgeNfe: async (
      period: string,
      body: Omit<NfeAcknowledgementRequest, "schemaVersion">,
      idempotencyKey: string,
    ) =>
      nfeAcknowledgementResultSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/nfe-workspace/periods/${period}/acknowledgements`,
          { schemaVersion: "1.0.0", ...body },
          idempotencyKey,
        ),
      ),

    /** START_REVIEW | VALIDATE | REOPEN with `If-Match: revision`; 409 while blocked. */
    validateNfePeriod: async (
      period: string,
      body: Omit<NfeValidationRequest, "schemaVersion">,
      revision: number,
      idempotencyKey: string,
    ) =>
      nfeValidationResultSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/nfe-workspace/periods/${period}/validation`,
          { schemaVersion: "1.0.0", ...body },
          idempotencyKey,
          undefined,
          revision,
        ),
      ),

    /** RULES runs now (200); AI is queued (202) or refused with 409 and the reasons. */
    runNfeAnalysis: async (
      period: string,
      kind: NfeAnalysisRequest["kind"],
      idempotencyKey: string,
    ) =>
      nfeAnalysisResultSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/nfe-workspace/periods/${period}/analysis`,
          { schemaVersion: "1.0.0", kind } satisfies NfeAnalysisRequest,
          idempotencyKey,
        ),
      ),

    getAcquisitionSettings: (signal?: AbortSignal, organizationId?: string) =>
      getParsed(
        acquisitionSettingsSchema,
        "/v1/acquisition-settings",
        undefined,
        signal,
        undefined,
        organizationId,
      ),

    updateAcquisitionSettings: async (
      update: AcquisitionSettingsUpdate,
      revision: number,
      organizationId?: string,
    ) =>
      acquisitionSettingsSchema.parse(
        await mutate<unknown>(
          "PUT",
          "/v1/acquisition-settings",
          update,
          undefined,
          organizationId,
          revision,
        ),
      ),

    getNfeWorkspaceSettings: (signal?: AbortSignal) =>
      getParsed(nfeWorkspaceSettingsSchema, "/v1/nfe-workspace/settings", undefined, signal),

    /** Administrators only; `If-Match: revision`. */
    updateNfeWorkspaceSettings: async (
      update: Omit<NfeWorkspaceSettingsUpdate, "schemaVersion">,
      revision: number,
    ) =>
      nfeWorkspaceSettingsSchema.parse(
        await mutate<unknown>(
          "PUT",
          "/v1/nfe-workspace/settings",
          { schemaVersion: "1.0.0", ...update },
          undefined,
          undefined,
          revision,
        ),
      ),

    getFactsShadowSummary: (days: number, signal?: AbortSignal) =>
      getParsed(
        factsShadowSummarySchema,
        "/v1/fiscal-facts/shadow-summary",
        { days: String(days) },
        signal,
      ),

    getFiscalFactsSettings: (signal?: AbortSignal) =>
      getParsed(fiscalFactsSettingsSchema, "/v1/fiscal-facts/settings", undefined, signal),

    updateFiscalFactsSettings: async (update: FiscalFactsSettingsUpdate, revision: number) =>
      fiscalFactsSettingsSchema.parse(
        await mutate<unknown>(
          "PUT",
          "/v1/fiscal-facts/settings",
          update,
          undefined,
          undefined,
          revision,
        ),
      ),

    createBrowserAgentViewerTicket: async () =>
      browserAgentViewerTicketSchema.parse(
        await mutate<unknown>("POST", "/v1/browser-agent/viewer-ticket"),
      ),

    listFiscalResearchTasks: (query: FiscalResearchTaskQuery = {}, signal?: AbortSignal) =>
      getParsed(
        fiscalResearchTaskPageSchema,
        "/v1/fiscal-research-tasks",
        listQuery(query),
        signal,
      ),

    getFiscalResearchTask: (taskId: string, signal?: AbortSignal) =>
      getParsed(fiscalResearchTaskSchema, `/v1/fiscal-research-tasks/${taskId}`, undefined, signal),

    createFiscalResearchTask: async (input: FiscalResearchTaskCreate, idempotencyKey?: string) =>
      fiscalResearchTaskSchema.parse(
        await mutate<unknown>("POST", "/v1/fiscal-research-tasks", input, idempotencyKey),
      ),

    retryFiscalResearchDispatch: async (input: {
      taskId: string;
      reason: string;
      revision: number;
      idempotencyKey: string;
    }) =>
      fiscalResearchTaskSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/fiscal-research-tasks/${input.taskId}/retry-dispatch`,
          { reason: input.reason },
          input.idempotencyKey,
          undefined,
          input.revision,
        ),
      ),

    getLotAnalysis: (taskId: string, signal?: AbortSignal) =>
      getParsed(lotAnalysisSchema, `/v1/fiscal-tasks/${taskId}/analysis`, undefined, signal),

    listFiscalTaskResults: (
      taskId: string,
      query: FiscalTaskResultQuery = {},
      signal?: AbortSignal,
    ) =>
      getParsed(
        fiscalTaskResultPageSchema,
        `/v1/fiscal-tasks/${taskId}/results`,
        listQuery({
          cursor: query.cursor,
          limit: query.limit ?? DEFAULT_PAGE_SIZE,
          itemId: query.itemId,
          q: query.q,
          status: query.status,
          route: query.route,
          ncm: query.ncm,
          issue: query.issue,
          sort: query.sort ?? "position",
          dir: query.dir ?? "asc",
        }),
        signal,
      ),

    createFiscalTask: async (input: FiscalTaskCreate, idempotencyKey?: string) =>
      fiscalTaskSchema.parse(
        await mutate<unknown>("POST", "/v1/fiscal-tasks", input, idempotencyKey),
      ),

    cancelFiscalTask: async (input: {
      taskId: string;
      revision?: number;
      idempotencyKey?: string;
    }) =>
      fiscalTaskSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/fiscal-tasks/${input.taskId}/cancel`,
          {},
          input.idempotencyKey,
          undefined,
          input.revision,
        ),
      ),

    retryFiscalTask: async (input: {
      taskId: string;
      reason?: string;
      revision?: number;
      idempotencyKey?: string;
    }) =>
      fiscalTaskSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/fiscal-tasks/${input.taskId}/retry`,
          input.reason ? { reason: input.reason } : {},
          input.idempotencyKey,
          undefined,
          input.revision,
        ),
      ),

    // Source selectors need the complete, small registry, not just its first page.
    listSources: async (signal?: AbortSignal): Promise<CursorPageResult<SourceListItem>> => {
      const items = new Map<string, SourceListItem>();
      const seen = new Set<string>();
      let cursor: string | undefined;
      for (let pageNumber = 0; pageNumber < 20; pageNumber += 1) {
        const page = await get<CursorPageResult<SourceListItem>>(
          "/v1/sources",
          { limit: 200, cursor },
          signal,
        );
        for (const source of page.items) items.set(source.id, source);
        if (!page.hasMore) {
          return {
            items: [...items.values()],
            hasMore: false,
            nextCursor: null,
            totalEstimate: page.totalEstimate,
          };
        }
        if (!page.nextCursor || seen.has(page.nextCursor)) {
          throw new Error("Source registry pagination did not advance");
        }
        seen.add(page.nextCursor);
        cursor = page.nextCursor;
      }
      throw new Error("Source registry exceeds the bounded loading limit");
    },

    getSource: (sourceId: string, signal?: AbortSignal) =>
      get<SourceDetail>(`/v1/sources/${sourceId}`, undefined, signal),

    triggerSourceRun: (input: {
      sourceId: string;
      reason?: string;
      maxDocuments?: number;
      idempotencyKey?: string;
    }) =>
      mutate<SourceRunQueued>(
        "POST",
        `/v1/sources/${input.sourceId}/runs`,
        {
          ...(input.reason ? { reason: input.reason } : {}),
          ...(input.maxDocuments ? { maxDocuments: input.maxDocuments } : {}),
        },
        input.idempotencyKey,
      ),

    createLinkRun: (input: LinkRunRequest & { idempotencyKey?: string }) =>
      mutate<SourceRunQueued>(
        "POST",
        "/v1/evidence/link-runs",
        {
          sourceId: input.sourceId,
          url: input.url,
          reason: input.reason,
        },
        input.idempotencyKey,
      ),

    getSourceRun: (runId: string, signal?: AbortSignal) =>
      getParsed(sourceRunSchema, `/v1/source-runs/${runId}`, undefined, signal),

    cancelSourceRun: (input: {
      runId: string;
      revision: number;
      idempotencyKey: string;
    }) =>
      mutate<unknown>(
        "POST",
        `/v1/source-runs/${input.runId}:cancel`,
        {},
        input.idempotencyKey,
        undefined,
        input.revision,
      ),

    listSourceRunEvidence: (
      runId: string,
      query: SourceRunEvidenceQuery = {},
      signal?: AbortSignal,
    ) =>
      getParsed(
        sourceRunEvidencePageSchema,
        `/v1/source-runs/${runId}/evidence`,
        listQuery({
          cursor: query.cursor,
          limit: query.limit ?? DEFAULT_PAGE_SIZE,
          sort: query.sort ?? "observedAt",
          dir: query.dir ?? "desc",
        }),
        signal,
      ),

    setSourcePaused: (input: { sourceId: string; paused: boolean }) =>
      mutate<SourceListItem>("PATCH", `/v1/sources/${input.sourceId}`, {
        status: input.paused ? "PAUSED" : "ACTIVE",
      }),

    replaySourceDlq: (input: { sourceId: string; request: DlqReplayRequest }) =>
      mutate<DlqReplayQueued>("POST", `/v1/sources/${input.sourceId}/dlq/replay`, input.request),

    /* -- Calculator research ("Buscar com agente?") --------------------------- */

    getCalculatorResearchSettings: (signal?: AbortSignal) =>
      getParsed(
        calculatorResearchSettingsSchema,
        "/v1/calculator-research/settings",
        undefined,
        signal,
      ),

    updateCalculatorResearchSettings: async (
      update: CalculatorResearchSettingsUpdate,
      revision: number,
    ) =>
      calculatorResearchSettingsSchema.parse(
        await mutate<unknown>(
          "PUT",
          "/v1/calculator-research/settings",
          update,
          undefined,
          undefined,
          revision,
        ),
      ),

    /** Read only: cost and time per gap, what an existing request already covers, AUTO caps and lanes. */
    estimateCalculatorResearch: async (input: CalculatorResearchEstimateRequest) =>
      calculatorResearchEstimateResultSchema.parse(
        await mutate<unknown>("POST", "/v1/calculator-research/requests:estimate", input),
      ),

    /** One gap. Keep one `Idempotency-Key` per user action so a retry replays instead of duplicating. */
    createCalculatorResearch: async (input: CalculatorResearchCreate, idempotencyKey: string) =>
      calculatorResearchCreateResultSchema.parse(
        await mutate<unknown>(
          "POST",
          "/v1/calculator-research/requests",
          input,
          idempotencyKey,
          undefined,
          undefined,
          CALCULATOR_RESEARCH_CREATE_TIMEOUT_MS,
        ),
      ),

    /** Up to 200 gaps of one origin. */
    createCalculatorResearchBatch: async (
      input: CalculatorResearchBatchCreate,
      idempotencyKey: string,
    ) =>
      calculatorResearchCreateResultSchema.parse(
        await mutate<unknown>(
          "POST",
          "/v1/calculator-research/requests:batch",
          input,
          idempotencyKey,
          undefined,
          undefined,
          CALCULATOR_RESEARCH_CREATE_TIMEOUT_MS,
        ),
      ),

    /** By origin, or every request of the organization when no origin is given (the Jobs page). */
    listCalculatorResearch: (
      query: {
        originKind?: CalculatorResearchOriginKind;
        originId?: string;
        status?: CalculatorResearchStatus[];
        mode?: CalculatorResearchMode;
        cursor?: string | null;
        limit?: number;
      } = {},
      signal?: AbortSignal,
    ) =>
      getParsed(
        calculatorResearchPageSchema,
        "/v1/calculator-research/requests",
        listQuery({ ...query, status: query.status?.join(",") }),
        signal,
      ),

    getCalculatorResearch: (requestId: string, signal?: AbortSignal) =>
      getParsed(
        calculatorResearchRequestSchema,
        `/v1/calculator-research/requests/${requestId}`,
        undefined,
        signal,
      ),

    cancelCalculatorResearch: async (input: {
      requestId: string;
      revision: number;
      reason: string;
      idempotencyKey?: string;
    }) =>
      calculatorResearchRequestSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/calculator-research/requests/${input.requestId}/cancel`,
          { schemaVersion: "1.0.0", reason: input.reason },
          input.idempotencyKey,
          undefined,
          input.revision,
        ),
      ),

    getCalculatorResearchOrigin: (
      originKind: CalculatorResearchOriginKind,
      originId: string,
      signal?: AbortSignal,
    ) =>
      getParsed(
        calculatorResearchOriginStateSchema,
        `/v1/calculator-research/origins/${originKind}/${originId}`,
        undefined,
        signal,
      ),

    listInsights: (signal?: AbortSignal) =>
      getParsed(insightFeedSchema, "/v1/insights", { limit: "20" }, signal),

    /** Always a NEW immutable calculation; the previous one is never changed. */
    recalculateCalculation: async (
      input: { calculationId: string; requestIds?: string[] },
      idempotencyKey: string,
    ) => {
      const body: CalculationRecalculate = {
        schemaVersion: "1.0.0",
        ...(input.requestIds?.length ? { requestIds: input.requestIds } : {}),
      };
      return calculationRevisionSchema.parse(
        await mutate<unknown>(
          "POST",
          `/v1/calculations/${input.calculationId}/recalculate`,
          body,
          idempotencyKey,
        ),
      );
    },

    listCalculationRevisions: (calculationId: string, signal?: AbortSignal) =>
      getParsed(
        calculationRevisionListSchema,
        `/v1/calculations/${calculationId}/revisions`,
        undefined,
        signal,
      ),

    listAudit: (query: AuditQuery, signal?: AbortSignal) =>
      get<CursorPageResult<AuditEntry>>("/v1/audit", listQuery(query), signal),
  };
}
